// extracted by mini-css-extract-plugin
export default {"wrapper":"F1UX1","image":"lxwxL"};